import { createRoute, lazyRouteComponent } from "@tanstack/react-router"
import { Route as RootRoute } from "../__root"

/**
 * `/onboarding/step-6` — stakeholders + users; finishes onboarding.
 * Page body lazy-loaded.
 */
export const Route = createRoute({
	getParentRoute: () => RootRoute,
	path: "/onboarding/step-6",
	component: lazyRouteComponent(() => import("./step-6.page")),
})
